import { render, staticRenderFns } from "./ProdesResiduosCaatinga.vue?vue&type=template&id=0aff587c&lang=pug"
import script from "./ProdesResiduosCaatinga.vue?vue&type=script&lang=js"
export * from "./ProdesResiduosCaatinga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports